/*
 * File: Toggle.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactToggle from 'react-toggle';

// Styles
import * as S from './Toggle.styles';


/**
 * Component
 */

export const Toggle = ({
	className, defaultChecked, checked, onChange, ...rest
}) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Render component
	return (
		<S.Wrapper className={className}>
			<ReactToggle icons={false} defaultChecked={defaultChecked} checked={checked} onChange={onChange} {...rest} />
		</S.Wrapper>
	);
};


/**
 * Configuration
 */

Toggle.displayName = 'Toggle';
Toggle.propTypes = {
	className: PropTypes.string,
	defaultChecked: PropTypes.bool,
	checked: PropTypes.bool,
	onChange: PropTypes.func
};
Toggle.defaultProps = {
	className: null,
	defaultChecked: undefined,
	checked: false,
	onChange: null
};
